import { useMemo } from 'react';
import { getLoggedInUser } from '../utils/jose';

export const useLoggedInUser = () => {
  const loggedInUser = useMemo(() => {
    const localObject = getLoggedInUser();
    return {
      ...localObject,
      DoctorId: localObject.UserId,
    };
  }, []);

  return loggedInUser;
};

export default useLoggedInUser;
